import React from "react";
import { render } from "storyblok-rich-text-react-renderer";
import RichTextTwoColumnImage from "../components/RichText/RichTextTwoColumnImage"

const RichText = ({ children }) => {
  return render(children, {
    blokResolvers: {
      'richtext_two_column_image': (props) => (
        <RichTextTwoColumnImage blok={props}/>
      ),
    },
  });
};

export default RichText;